import { useSelector } from "react-redux";
import ItemsHeader from "../../../presentational/customerItems/ItemsHeader";
import { getUserIsAuthenticated } from "../../../../state/selectors";

const ItemsHeaderContainer = props => {
  const isAuthenticated = useSelector(getUserIsAuthenticated);

  return <ItemsHeader {...{ ...props, isAuthenticated }} />;
};

export default ItemsHeaderContainer;
